
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"34","height":"34","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.1 23.9l23.8 4.4 1.062-5.8H5.358L5.1 23.9z","stroke":"#47AEA6","stroke-width":"2","stroke-miterlimit":"10","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M2.3 7.7h29.5v14.8H2.3V7.7z","stroke":"#47AEA6","stroke-width":"2","stroke-miterlimit":"10","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M17 19.7a4.6 4.6 0 100-9.2 4.6 4.6 0 000 9.2z","fill":"#F9A91E"}}),_c('path',{attrs:{"d":"M19 16.2c0 .4-.2.7-.4 1-.3.3-.7.4-1.3.5v.9h-.6v-.9c-.7 0-1.3-.1-1.7-.3v-.9c.2.1.5.2.8.3.3.1.6.1.9.1v-1.6s-1.2-.5-1.4-.8c-.2-.2-.3-.5-.3-.8 0-.4.2-.7.5-1 .3-.3.7-.4 1.2-.5v-.7h.6v.7c.6 0 1.1.1 1.6.3l-.3.8c-.4-.2-.8-.3-1.3-.3v1.5l.3.1c.5.2.9.4 1.1.7.2.3.3.6.3.9zm-3-2.5c0 .2.1.3.2.4.1.1.3.2.5.3v-1.3c-.2 0-.4.1-.5.2-.1.1-.2.2-.2.4zm2 2.6c0-.2-.1-.3-.2-.4-.1-.1-.3-.2-.6-.3v1.3c.6-.1.8-.3.8-.6z","fill":"#fff"}})])
          )
        }
      }
    